/* ================================================================
   RECARO Exo LP — main.js
   ================================================================ */
(function () {
  'use strict';

  /* ── ハンバーガーメニュー ── */
  const hamburger = document.getElementById('js-hamburger');
  const nav       = document.getElementById('js-nav');

  if (hamburger && nav) {
    hamburger.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      hamburger.classList.toggle('is-active', isOpen);
      hamburger.setAttribute('aria-expanded', String(isOpen));
      hamburger.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    });
    // ナビリンク押下でメニューを閉じる
    nav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        nav.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── スクロールでヘッダー背景を強化 ── */
  const header = document.getElementById('js-header');
  if (header) {
    const onScroll = () =>
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── スクロールリビール ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.js-reveal').forEach(el => observer.observe(el));
  } else {
    // フォールバック
    document.querySelectorAll('.js-reveal').forEach(el =>
      el.classList.add('is-visible')
    );
  }

  /* ── スムーススクロール ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const id     = anchor.getAttribute('href').slice(1);
      const target = id ? document.getElementById(id) : document.body;
      if (!target) return;
      e.preventDefault();
      const headerH = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerH;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  /* ── スクロール進行バー (極細) ── */
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let progressBar = document.querySelector('.lp-progress__bar');
  if (!progressBar) {
    const wrap = document.createElement('div');
    wrap.className = 'lp-progress';
    wrap.setAttribute('aria-hidden', 'true');
    progressBar = document.createElement('span');
    progressBar.className = 'lp-progress__bar';
    wrap.appendChild(progressBar);
    document.body.appendChild(wrap);
  }
  let progressRaf;
  function updateProgress() {
    const h = document.documentElement;
    const max = h.scrollHeight - h.clientHeight;
    const pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
    progressBar.style.width = pct + '%';
    progressRaf = null;
  }
  window.addEventListener('scroll', () => {
    if (!progressRaf) progressRaf = requestAnimationFrame(updateProgress);
  }, { passive: true });
  updateProgress();

  /* ── パララックス (FV / CTA / 巨大数字) ── */
  const parallaxTargets = [];
  document.querySelectorAll('[data-parallax]').forEach(el => {
    const speed = parseFloat(el.dataset.parallax) || -0.06;
    parallaxTargets.push({ el, speed, anchor: el.closest('[data-parallax-anchor]') || el.parentElement });
  });
  let plxRaf;
  function tickParallax() {
    if (reduced) return;
    parallaxTargets.forEach(({ el, speed, anchor }) => {
      const rect = anchor.getBoundingClientRect();
      const center = rect.top + rect.height / 2 - window.innerHeight / 2;
      el.style.transform = `translate3d(0, ${(center * speed).toFixed(2)}px, 0)`;
    });
    plxRaf = null;
  }
  if (parallaxTargets.length && !reduced) {
    window.addEventListener('scroll', () => {
      if (!plxRaf) plxRaf = requestAnimationFrame(tickParallax);
    }, { passive: true });
    tickParallax();
  }

  /* ── カウントアップ (data-count-to) ── */
  if ('IntersectionObserver' in window) {
    const countObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        countObs.unobserve(el);
        if (reduced) {
          el.textContent = parseInt(el.dataset.countTo, 10).toLocaleString();
          return;
        }
        const target = parseInt(el.dataset.countTo, 10);
        const fromAttr = el.dataset.countFrom;
        const from = fromAttr !== undefined ? parseInt(fromAttr, 10) : 0;
        const dur = parseInt(el.dataset.countDuration, 10) || 1800;
        const noFormat = el.dataset.countFormat === 'plain' || fromAttr !== undefined;
        const fmt = (n) => noFormat ? String(n) : n.toLocaleString();
        const start = performance.now();
        function step(now) {
          const t = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = fmt(Math.floor(from + (target - from) * eased));
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = fmt(target);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-count-to]').forEach(el => countObs.observe(el));
  }

  /* ── Warranty SVG draw "5" ── */
  if ('IntersectionObserver' in window) {
    const svgObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed-num');
        svgObs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-warranty-svg]').forEach(el => svgObs.observe(el));
  } else {
    document.querySelectorAll('[data-warranty-svg]').forEach(el => el.classList.add('is-revealed-num'));
  }

})();
